// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import cn from 'classnames';
import React, {useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import * as support_lib from '../support_lib';
import {i_svg_props, Svg} from '../shared/svg';
import Icon_sup_help from '../img/svg/icon/sup_help.svg';
import Icon_sup_fix from '../img/svg/icon/sup_fix.svg';
import Icon_sup_billing from '../img/svg/icon/sup_billing.svg';
import Icon_sup_setup from '../img/svg/icon/sup_setup.svg';
import Icon_sup_alert from '../img/svg/icon/sup_alert.svg';
import Icon_sup_email from '../img/svg/icon/sup_email.svg';
import Icon_sup_license from '../img/svg/icon/sup_license.svg';
import Icon_sup_lock from '../img/svg/icon/sup_lock.svg';

interface i_support_item extends i_svg_props {
    title: string;
    href: string;
}
export const legal_items: i_support_item[] = [{
    href: '/legal/privacy',
    icon: <Icon_sup_lock width={24} height={24}/>,
    title: 'Privacy Policy',
}, {
    href: '/legal/sla',
    icon: <Icon_sup_license width={24} height={24}/>,
    title: 'End User License',
}];

export const support_items: i_support_item[] = [{
    href: '/faq',
    icon: <Icon_sup_help width={24} height={24}/>,
    title: 'General Information',
}, {
    href: '/support/troubleshooting',
    icon: <Icon_sup_fix width={24} height={24}/>,
    title: 'Troubleshooting',
}, {
    href: '/support/billing',
    icon: <Icon_sup_billing width={24} height={24}/>,
    title: 'Billing and Payments',
}, {
    href: '/plus_setup',
    icon: <Icon_sup_setup width={24} height={24}/>,
    title: 'Setup Guides',
}, {
    href: '/premium_support',
    icon: <Icon_sup_alert width={24} height={24}/>,
    title: 'Report a Problem',
}, {
    href: '/contact',
    icon: <Icon_sup_email width={24} height={24}/>,
    title: 'Contact Us',
}];

export const Support_item = (props: i_support_item)=>{
    const {title, href, ...img_props} = props;
    return <Link to={href} className="support_item">
      <Svg {...img_props} />
      <h3>{title}</h3>
    </Link>;
};

interface i_support_container_props {
    cls?: string;
}

export const Support_container = (props: i_support_container_props)=>{
    const {cls} = props;
    const [q, set_q] = useState('');
    const [res] = support_lib.use_faq({q});
    const results = res.map(({id, title, path, icon})=>({
        title, to: `${path}#${id}`, path, icon}));
    const on_change = ev=>set_q(ev.target.value);
    const history = useHistory();
    const on_press = ev=>{
        if (ev.keyCode==13 && results.length)
            history.push(results[0].to);
    };
    return <div className={cn('container hola_support', cls)}>
      <support_lib.Search q={q} results={results}
        on_change={on_change} on_press={on_press}/>
      <div className="hola_support-items">
        {support_items.map((data, i)=><Support_item key={i} {...data}/>)}
      </div>
    </div>;
};
